export type MagentoImageFormat = "avif" | "webp";

type GetOptimizedMagentoImageUrlParams = {
  url: string;
  width?: number;
  height?: number;
  quality?: number;
  format?: MagentoImageFormat;
};

const isPositiveNumber = (value: number | undefined): value is number =>
  typeof value === "number" && Number.isFinite(value) && value > 0;

export const getOptimizedMagentoImageUrl = ({
  url,
  width,
  height,
  quality,
  format,
}: GetOptimizedMagentoImageUrlParams): string => {
  if (!url.startsWith("http")) {
    return url;
  }

  try {
    const parsedUrl = new URL(url);

    parsedUrl.searchParams.set("fit", "scale-down");

    // Magento image transformations are served from the /images path, so keep
    // existing optimized URLs intact and route raw media URLs through it.
    if (!parsedUrl.pathname.startsWith("/images/")) {
      parsedUrl.pathname = `/images${parsedUrl.pathname}`;
    }

    if (isPositiveNumber(width)) {
      parsedUrl.searchParams.set("width", width.toString());
    }

    if (isPositiveNumber(height)) {
      parsedUrl.searchParams.set("height", height.toString());
    }

    if (isPositiveNumber(quality)) {
      parsedUrl.searchParams.set("quality", quality.toString());
    }

    if (format) {
      parsedUrl.searchParams.set("format", format);
    }

    return parsedUrl.toString();
  } catch {
    return url;
  }
};
